












































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Types
import { IAddressForm } from "@/models/addresses";

// Mixins
import CountriesStore from "@/mixins/constants/countriesStore";
import Context from "@/mixins/context";
import BrandMixin from "@/mixins/brandMixin";

// Types
import { IState } from "@/store";
import { ICountry } from "@/models/constants";
import { BrandConfigKeys } from "@/data/constants";

@Component({
  components: {
    "region-field": () =>
      import("@/components/app/global/address/regionField.vue")
  },
  computed: {
    ...mapState({
      brandCountryId: (state: IState) => state.brand.country_id
    })
  }
})
export default class AddressForm extends Mixins(
  Context,
  CountriesStore,
  BrandMixin
) {
  // :getters
  public brandCountryId!: ICountry["id"];

  @Prop({ required: true })
  public value!: IAddressForm;

  @Prop({ required: true })
  public isProcessing!: boolean;

  @Prop({ default: true })
  public withRegion!: boolean;

  // Computed

  public get form() {
    return this.value;
  }

  public set form(value) {
    this.$emit("input", value);
  }

  public get country() {
    return this.$_.find(
      this.countries,
      country => country.id === this.form.country_id
    );
  }

  public get isRegionRequiredInAddress() {
    return !!(this.$store.state as IState).brand.config[
      BrandConfigKeys.REQUIRE_REGION_IN_ADDRESS
    ];
  }

  // Life-cycle methods

  public async created() {
    this.getConfig();

    if (!this.form.country_id) {
      this.form.country_id = this.brandCountryId;
      this.$emit("input", this.form);
    }

    if (this.withRegion && this.form.country_id !== "") {
      await this.loadRegions();
    }
  }

  // Methods

  public loadRegions() {
    return this.$store.dispatch("constants/getRegions", {
      countryId: this.$_.get(this.country, "id"),
      countryCode: this.$_.get(this.country, "code")
    });
  }

  public async onCountryChange() {
    this.form.region_id = null;
    if (this.withRegion) {
      await this.loadRegions();
    }
  }

  public getConfig() {
    return this.$store.dispatch("brand/getConfig", {
      keys: [BrandConfigKeys.REQUIRE_REGION_IN_ADDRESS],
      brandId: this.isMockClientContext
        ? this.$store.state.user.upmind_brand_id
        : this.brandId
    });
  }
}
